import React, { useEffect, useState } from 'react';
import connect from "react-redux/es/components/connect";
import Box from '@mui/system/Box';
import {
    FormLabel, FormControl, AccordionSummary, Accordion, AccordionDetails, Typography,
    Select, MenuItem, TextField, Button, OutlinedInput
} from '@mui/material';
import { DesktopDatePicker } from "@mui/x-date-pickers";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { formatDate, getVFASOList, actionGetSupervisorLoginList } from "../store/action/RemoteActionSupervisor";
import translate from "../i18n/translate";
import { resetTimout } from "./common/FirebaseSupervisor";

const SupervisorLoginList = (props) => {
    const [language, setLanguage] = useState("");
    const [searchField, setSearchField] = useState(0);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [dateFrom, setDateFrom] = useState(null);
    const [dateTo, setDateTo] = useState(null);
    const [supervisorLoginList, setSupervisorLoginList] = useState(null);

    const onClickSearch = () => {
        resetTimout();
        const requestBody = {
            SearchField: searchField,
            SearchKeyword: searchKeyword,
            SearchDateFrom: dateFrom ? formatDate(dateFrom) : '',
            SearchDateTo: dateTo ? formatDate(dateTo) : '',
        };
        props.actionGetSupervisorLoginList(requestBody);
        setSupervisorLoginList([]);
    };

    const handleChange = (e) => {
        resetTimout();
        let eventValue = e.target.value;
        switch (e.target.name) {
            case "search-field":
                eventValue = parseInt(eventValue);
                setSearchField(eventValue);
                if (eventValue === 0) {
                    setSearchKeyword("");
                }
                break;
            case "search-keyword":
                setSearchKeyword(eventValue);
                break;
            default:
                console.log(e.target.name);
        }
    };

    const handleDateFromChange = (e) => {
        resetTimout();
        setDateFrom(e);
    };

    const handleDateToChange = (e) => {
        resetTimout();
        setDateTo(e);
    };

    useEffect(() => {
        if (props?.supervisorLoginList?.length > 0) {
            setSupervisorLoginList(props.supervisorLoginList);
        }
    }, [props.supervisorLoginList]);

    useEffect(() => {
        setLanguage(localStorage.getItem("locale"));
        const requestBody = {
            SearchField: 0,
            SearchKeyword: ''
        };
        props.actionGetSupervisorLoginList(requestBody);
    }, []);

    return (
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-SupervisorLoginList')}</h2>

            <Box sx={{ display: 'flex' }}>
                <Accordion sx={{ display: 'nowrap', marginBottom: '10' }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography>{translate('Filters')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <FormControl required component="fieldset" sx={{ m: 3, width: 250 }} variant="standard">
                            <Select id="search-field" name="search-field" value={searchField} label={translate('SearchField')} onChange={handleChange}>
                                <MenuItem value={0}><em>{translate('Select-SearchField')}</em></MenuItem>
                                <MenuItem value={1}>{translate('AdminID')}</MenuItem>
                                <MenuItem value={2}>{translate('IPAddress')}</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl required component="fieldset" sx={{ m: 3, width: 250 }} variant="standard">
                            <TextField id="search-keyword" name="search-keyword" value={searchKeyword} label={translate('SearchKeyword')} variant="outlined" size="small" onChange={handleChange} />
                        </FormControl>

                        <br />
                        <FormControl required component="fieldset" sx={{ m: 3, width: 160 }} variant="standard">
                            <DesktopDatePicker
                                id="id_DateFrom"
                                name="id_DateFrom"
                                label={translate('Search-DateFrom')}
                                inputFormat="yyyy/MM/dd"
                                value={dateFrom}
                                onChange={handleDateFromChange}
                                className='input-bordered'
                                renderInput={(params) => <TextField {...params} />}
                            />
                            <DesktopDatePicker
                                id="id_DateTo"
                                name="id_DateTo"
                                label={translate('Search-DateTo')}
                                inputFormat="yyyy/MM/dd"
                                value={dateTo}
                                onChange={handleDateToChange}
                                className='input-bordered'
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </FormControl>

                        <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                            <Button variant="contained" onClick={() => onClickSearch()}>{translate('btnSearch')}</Button>
                        </FormControl>
                    </AccordionDetails>
                </Accordion>
            </Box>

            <div className="gaps-3x" />
            <table className="adminTable" style={{ width: 890 }}>
                <tbody>
                    <tr className="adminTR">
                        <th className="adminTH" style={{ width: '7%' }}>{translate('VFASPID')}</th>
                        <th className="adminTH" style={{ width: '28%' }}>{translate('AdminID')}</th>
                        <th className="adminTH" style={{ width: '14%' }}>{translate('IPAddress')}</th>
                        <th className="adminTH" style={{ width: '18%' }}>{translate('LoginDate')}</th>
                        <th className="adminTH" style={{ width: '18%' }}>{translate('LogoutDate')}</th>
                        <th className="adminTH" style={{ width: '15%' }}>{translate('LogoutType')}</th>
                    </tr>
                    {supervisorLoginList?.map((log, index) => {
                        return <tr className="adminTR" key={log.AUTORECID}>
                            <td className="adminTD" width='7%' align='center'>{log.VFASPID}</td>
                            <td className="adminTD" width='28%' align='center'>{log.AdminID}</td>
                            <td className="adminTD" width='14%' align='center'>{log.IPAddress}</td>
                            <td className="adminTD" width='18%' align='left'>{log.LoginDate}</td>
                            <td className="adminTD" width='18%' align='left'>{log.LogoutDate}</td>
                            <td className="adminTD" width='15%' align='center'>{log.LogoutType}</td>
                        </tr>
                    })
                    }
                </tbody>
            </table>

        </div>

    );
};

const mapStateToProps = state => {
    return {
        supervisorLoginList: state.remote.supervisorLoginList
    };
};

export default connect(mapStateToProps, {
    actionGetSupervisorLoginList
})(SupervisorLoginList);
